import Head from 'next/head';
import React from 'react';

import ContactPage from '../../components/ContactPage';
import { pageTitle } from '../../components/shared/basic/customHead';

const Contact = () => {
  return (
    <>
      <Head>
        <title>{pageTitle('Contact Us')}</title>
      </Head>
      <div>
        <ContactPage />
      </div>
    </>
  );
};

export default Contact;
